import React, { useState, useEffect, useRef } from 'react';

import { useAddress, 
        ConnectWallet, 
        useSwitchChain,
        useChainId } from "@thirdweb-dev/react";
import { Binance } from "@thirdweb-dev/chains";

const Header = () => {
    const menuRef = useRef()
    const address = useAddress();
    const switchChain = useSwitchChain();
    const chainId = useChainId();

    const handleMenu = () => {
        console.log(document.querySelector('#burger-wrapper, .menu .button-text').click())
    }

    useEffect(() => {
        if( address && chainId !== Binance.chainId ) {
          try {
            switchChain(Binance.chainId) 
          } catch(e) {
            console.error(e)
          }
        }
    }, [address, chainId])

    return (
        <header className="classic-menu invert-header" data-menucolor="#171717">
            <div id="header-container">
                <div id="logo" className="hide-ball">
                    <a className="ajax-link" data-type="page-transition" href="/">
                        <img className="black-logo" src="/images/logo-02.gif" alt="H3M Logo" />
                        <img className="white-logo" src="/images/logo-02-white.gif" alt="H3M Logo" />
                    </a>
                </div>
                <nav> 
                    <div className="nav-height">
                        <div className="outer">
                            <div className="inner">           
                                <ul data-breakpoint="1025" className="flexnav">
                                    <li className="link menu-timeline"><a className="" href="/creative.html"><div className="before-span">Creative</div></a></li>
                                    <li className="link menu-timeline"><a className="" href="/metaverse.html"><div className="before-span">Metaverse</div></a>
                                        <ul>                                            
                                            <li className="link menu-timeline"><a className="" href="/token.html"><div className="before-span">Token</div></a></li>
                                            <li className="link menu-timeline"><a className="" href="/staking"><div className="before-span">Staking</div></a></li>
                                        </ul>
                                    </li>
                                    <li className="link menu-timeline"><a className="" href="/"><div className="before-span">Apps</div></a>
                                        <ul>                                            
                                            <li className="link menu-timeline"><a className="" href="/apps-portals.html"><div className="before-span">Portals</div></a></li>
                                            <li className="link menu-timeline"><a className="" href="/apps-carbon.html"><div className="before-span">Carbon</div></a></li>
                                            <li className="link menu-timeline"><a className="" href="/apps-domain.html"><div className="before-span">Domain</div></a></li>
                                            <li className="link menu-timeline"><a className="" href="/apps-matter.html"><div className="before-span">Matter</div></a></li>
                                        </ul>
                                    </li>
                                    <li className="link menu-timeline"><a className="ajax-link" data-type="page-transition" href="/studio.html"><div className="before-span">Studio</div></a></li>
                                    
                                    <li className="link menu-timeline"><a className="ajax-link" data-type="page-transition" href="/contact.html"><div className="before-span">Contact</div></a></li>
                                    <li className="link menu-timeline wallet"
                                            style={{
                                                paddingTop: '0px',
                                                paddingBottom: '0px'
                                            }} onClick={handleMenu}>
                                        <ConnectWallet 
                                            className="connect-button"
                                            theme="light"
                                            style={{ marginTop: '12px'}}
                                            // style={{ textTransform: 'uppercase', backgroud: "transparent", marginTop: "-20px", height: "55px" }}
                                        />
                                    </li>
                                </ul>            
                            </div>
                        </div> 
                    </div>          
                </nav>
                <div className="button-wrap right menu burger-lines" ref={menuRef}>
                    <div className="icon-wrap parallax-wrap">
                        <div className="button-icon parallax-element">
                            <div id="burger-wrapper">
                                <div id="menu-burger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="button-text sticky right"><span data-hover="Menu">Menu</span></div> 
                </div>
            </div>
        </header>
    )
}

export default Header;